import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
// Sections

import TemplateRenderer from "../../components/template-renderer/TemplateRenderer";
import { useGroupSignUpStyles } from "../group-sign-up/GroupSignUpTemplate";
import OptInWelcome from "../../sections/opt-in-welcome/OptInWelcome";
import PropAndRewards from "../../sections/prop-rewards/PropAndRewards";
import Testimonials from "../../sections/testimonials/Testimonials";
import RichText from "../../sections/rich-text/RichText";
import StepsContent from "../../sections/steps-content/StepsContent";
import ExampleQuestions from "../../sections/example-questions/ExampleQuestions";
import OptInCta from "../../sections/opt-in-cta/OptInCta";
import BrandLearningTabHeader from "../../sections/brand-learning-tab-header/BrandLearningTabHeader";
import TextWithMeadia from "../../sections/text-with-media/TextWithMeadia";
import TestimonialsWithMedia from "../../sections/testimonials-with-media/TestimonialsWithMedia";
import CanCannotAnswer from "../../sections/can-cannot-answer/CanCannotAnswer";
const SECTIONS = {
  "opt-in-welcome": OptInWelcome,
  header: BrandLearningTabHeader,
  "text-with-media": TextWithMeadia,
  "can-cannot-answer": CanCannotAnswer,
  "prop-rewards": PropAndRewards,
  steps: StepsContent,
  testimonials: Testimonials,
  "example-questions": ExampleQuestions,
  "rich-text": RichText,
  "testimonials-with-media": TestimonialsWithMedia,
  "opt-in-cta": OptInCta
};
const useStyles = makeStyles(theme => ({
  ...useGroupSignUpStyles(theme)
}));
const OnboardingOptInTemplate = ({
  content,
  optInCtaClick
}) => {
  const classes = useStyles();
  if (!content || !content.sections) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Grid, {
    className: classes.container
  }, /*#__PURE__*/React.createElement(TemplateRenderer, {
    content: content,
    sectionComponentMapping: SECTIONS,
    optInCtaClick: optInCtaClick,
    leftSpaceContainer: classes.leftSpaceContainer,
    subHeaderContainer: classes.subHeaderContainer,
    useAltDesign: true
  }));
};
export default OnboardingOptInTemplate;
OnboardingOptInTemplate.propTypes = {
  content: PropTypes.object.isRequired,
  optInCtaClick: PropTypes.func
};